export default "<lib-api-list [widget]=\"true\"></lib-api-list>"